import { Box } from "@mantine/core";
import React, { useEffect } from "react";

interface ImageViewProps {
  style?: React.CSSProperties;
  url?: string;
  file?: File | null;
  alt?: string;
  imageSize?: { width: number; height: number };
}

const ImageView: React.FC<ImageViewProps> = ({ url, file, alt, imageSize, style }) => {
  const [src, setSrc] = React.useState<string | null>(null);
  const [key, setKey] = React.useState<string | null>(null);

  useEffect(() => {
    if (file) {
      setSrc(URL.createObjectURL(file));
      setKey(file.name);
    } else if (url) {
      setSrc(url);
      setKey(url);
    } else {
      setSrc(null);
      setKey(null);
    }
  }, [file, url]);

  return (
    <>
      {
        <Box
          key={key}
          style={{
            ...style,
            width: imageSize?.width || "100%",
            height: imageSize?.height || "100%",
          }}
        >
          <img
            src={src}
            alt={alt || ""}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            crossOrigin="anonymous"
          />
        </Box>
      }
    </>
  );
};

export default ImageView;
